<template>
    <v-dialog v-model="dialog" width=900 persistent>
        <v-card>
            <v-form ref="formReceta" v-model="formValid">

                <v-toolbar color="primary" dark dense>
                    <v-toolbar-title>Surtir receta</v-toolbar-title>
                    <v-spacer/>
                    <v-btn text @click="cancela">
                        <v-icon>mdi-close-box</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="px-2">
                    <v-sheet elevation="2" class="pa-2">

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model.number="dat.cip"
                                    rounded
                                    filled
                                    dense
                                    type="number"
                                    label="Paciente"
                                    append-outer-icon="mdi-magnify"
                                    @click:append-outer="dialogBuscaPaciente=true"
                                    :rules="[v => !!v || 'Requerido.']"
                                />
                                <v-text-field
                                    v-model="pac.nombreCompleto"
                                    label="Nombre"
                                    rounded
                                    outlined
                                    dense
                                    readonly
                                    :rules="[v => !!v || 'Requerido.']"
                                />
                                <select-personal
                                    label="Médico que receta"
                                    :model.sync="dat.medico"
                                    :rules="[v => !!v || 'Requerido.']"
                                />

                            </v-col>
                            <v-col cols="12" sm="6">
                                <!--
                                <v-text-field
                                    v-model="dat.fecha"
                                    label="Fecha de elaboración"
                                    rounded
                                    filled
                                    dense
                                    :rules="[v => !!v || 'Requerido.']"
                                />
                                -->
                                <select-fecha
                                    label="Fecha de elaboración"
                                    :model.sync="dat.fecha"
                                    :rules="[v => !!v || 'Requerido.']"
                                    :dense="true"
                                />
                                <v-text-field
                                    v-model="dat.folio"
                                    label="Folio de la receta"
                                    rounded
                                    filled
                                    dense
                                    :rules="[v => !!v || 'Requerido.']"
                                />
                                <v-textarea
                                    label="Observaciones"
                                    v-model="dat.observaciones"
                                    rounded
                                    filled
                                />
                            </v-col>
                        </v-row>
                    </v-sheet>
                    <v-toolbar color="primary" dark dense flat>
                        <v-toolbar-title>Medicamentos</v-toolbar-title>
                        <v-spacer/>
                        <v-btn text @click="agregaMedicamento">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-data-table
                        item-key="id"
                        loading-text="Buscando... espere"
                        :headers="headers"
                        :items="medicamentos"
                        disable-filtering
                        disable-pagination
                        hide-default-footer
                        disable-sort
                    >
                        <!--
                            <template v-slot:[`item.fecha`]="{ item }">
                                <span v-html="item.fecha"></span>
                            </template>
                        -->
                    </v-data-table>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>

                    <v-btn text color="error" @click="cancela">
                        Cancelar
                    </v-btn>
                    <v-btn color="success" @click="guarda" :disabled="!formValid">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <busca-paciente
            :dialogBuscaPaciente.sync="dialogBuscaPaciente"
            :paciente.sync="dat.cip"
            :todos="true"
        />
    </v-dialog>
</template>

<script>
export default {
    components:{
        'busca-paciente':()=>import('@/components/hospital/buscaPaciente'),
        'select-personal':()=>import('@/components/com/SelectPersonal'),
        'select-fecha':()=>import('@/components/com/SelectEditaFecha'),
    },
    props:{
        dialogModal: Boolean,
        datos: Object,
    },

    data:()=>({
        formValid:false,

        dialogBuscaPaciente:false,
        pac:{},
        dat:{},
        loadingPac:false,
        headers:[
            {text:'Medicamento', value:'medicamento'},
            {text:'Cantidad', value:'cantidad'},
            {text:'Entregado', value:'entregado'},
            {text:'Rótulo', value:'rotulo'},
            {text:'', value:'acciones'},
        ],
        medicamentos:[],
    }),

    methods:{
        agregaMedicamento(){
            console.log(this.dat)
        },
        async guarda(){
            let params = {
                pacienteId:this.dat.cip,
                diagnosticoId:8164,
                diagnosticoDgis:8229,
                recomendaciones:"No hay recomendaciones",
            }
            console.log(params)
            this.dialog=false
        },
        cancela(){
            this.dialog=false
        },
        async cargaPaciente(paciente){
            try{
                this.loadingPac=true
                let req = await this.$http({
                    url:'/pacientes/listV2',
                    method:'GET',
                    params:{id:paciente}
                })
                this.loadingPac=false
                let datos = req.data
                if (datos.pacienteId){
                    this.pac = datos
                } else {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'No existe',
                        text: 'No se encuentran registros para el paciente '+paciente,
                    })
                }
            }catch(err){
                this.loadingPac=false
                this.$store.dispatch('security/revisaError',err)
            }
        },
    },

    computed:{
        dialog:{
            get(){return this.dialogModal},
            set(val){this.$emit('update:dialogModal',val)}
        },
    },
    watch:{
        dialog(v){
            if (!v){
                this.$refs.formReceta.reset()
            }
        },
        'dat.cip'(val){
            if (val >= 10000099){
                this.cargaPaciente(val)
            } else{
                this.pac = {}
            }

        },
    },
}
</script>

<style>

</style>